import "jquery-validation-unobtrusive";

import Common from './common';
import EncryptModel from "./encrypt.model";

export default class PasswordModel {
	private passwordFormControl: Common;
	private $passwordActionFormSelector: string = '#passwordForm';
	private $passwordChnageFormSelector: string = '#changePasswordForm';
	private $form: JQuery<HTMLElement>;
	
	public initialize(): void {
		this.passwordFormControl = new Common('#passwordForm');

		$('#password, #confirmPassword').on('input focus', function () {
			validatePassword($(this).val());
		});

		this.$form = $(this.$passwordActionFormSelector);
		var currentForm = this.$passwordActionFormSelector;
		if (this.$form.length < 1) {
			this.$form = $(this.$passwordChnageFormSelector);
			currentForm = this.$passwordChnageFormSelector;
		}

		this.$form.submit(event => new EncryptModel(currentForm));
	}
}

window.passwordModel = new PasswordModel();

function validatePassword(inputValue) {
	var minMaxLength = /^[\s\S]{8,20}$/,
		upper = /[A-Z]/,
		lower = /[a-z]/,
		number = /[0-9]/,
		special = /[ !#$%&()*+,\-/:;=@[\\\]^_{|}~]/;
	//special = /[ !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/;	

	if (upper.test(inputValue)) {
		toggleClass("upper", true);
	} else {
		toggleClass("upper", false);
	}

	if (lower.test(inputValue)) {
		toggleClass("lower", true);
	} else {
		toggleClass("lower", false);
	}

	if (number.test(inputValue)) {
		toggleClass("number", true);
	} else {
		toggleClass("number", false);
	}

	if (special.test(inputValue)) {
		toggleClass("special", true);
	} else {
		toggleClass("special", false);
	}

	if (minMaxLength.test(inputValue)) {
		toggleClass("min-length", true);
	} else {
		toggleClass("min-length", false);
	}
}

function toggleClass(className, flag) {
	if (flag) {
		$("." + className).removeClass("fa-minus-circle");
		$("." + className).addClass("fa-check-circle");
	} else {
		$("." + className).removeClass("fa-check-circle");
		$("." + className).addClass("fa-minus-circle");
	}
}



// WEBPACK FOOTER //
// ./Client/Scripts/models/password.model.ts